export const itemModel = {
  id: "",
  name: "",
  title: "",
  sentence: "",
  body: "",
  label: "",
  color: "",
  index: "",
  edit: false,
  categories: [],
  highlight: false,
  tags: [],
  effort: [],
  priorities: [],
  phases: [],
  brand: [],
  items: [],
  regulation: false,
  scores: {
    slider1: 0,
    slider2: 0,
    regulation: false,
  },
  children: [],
};

export const initialState = () => {
  return {
    id: "",
    name: "",
    title: "",
    sentence: "",
    body: "",
    label: "",
    color: "",
    index: "",
    edit: false,
    categories: [],
    highlight: false,
    tags: [],
    effort: [],
    priorities: [],
    phases: [],
    brand: [],
    items: [],
    regulation: false,
    scores: {
      slider1: 0,
      slider2: 0,
      regulation: false,
    },
    children: [],
  };
};

export const getBorderColor = (rounded) => {
  if (rounded >= 4.0) {
    return '#4CAF50'
  } else if (rounded >= 3.0) {
    return '#FFC107'
  } else if (rounded >= 2.0) {
    return '#FFC107'
  } else {
    return '#F44336'
  }
};

export const initialScores = () => {
  return {
    slider1: 0,
    slider2: 0,
    regulation: false,
  };
};

export const calculateRolloutPriorityScore = (input) => {
  // Define weights
  const weights = {
    effort: 0.5,   // slider1
    impact: 0.5    // slider2
  };

  const effort = input.slider1 ?? 0;
  const impact = input.slider2 ?? 0;
  const regulation = !!input.regulation;

  // If it's mandatory, skip scoring logic
  if (regulation) {
    return {
      score: 5,
      recommendation: 'Immediate Rebrand (Mandatory Requirement)'
    };
  }

  // Compute weighted score
  // Effort is inverted so low effort = high readiness
  const score =
    ((6 - effort) * weights.effort) +
    (impact * weights.impact);

  const rounded = Math.round(score * 100) / 100;

  // Interpretation bands
  let recommendation;
  if (rounded >= 4.0) {
    recommendation = 'Immediate Rebrand (Day 1)';
  } else if (rounded >= 3.0) {
    recommendation = 'Priority Phase (Day 180)';
  } else if (rounded >= 2.0) {
    recommendation = 'Endorsed Legacy Brand';
  } else {
    recommendation = 'Deferred / Low Priority';
  }

  return { score: rounded, recommendation };
};


export const colors = [
  { title: "None", color: "" },
  { title: "Red", color: "#F44336" },
  { title: "Dark Red", color: "#B71C1C" },
  { title: "Pink", color: "#E91E63" },
  { title: "Purple", color: "#9C27B0" },
  { title: "Dark Purple", color: "#673AB7" },
  { title: "Light Purple", color: "#E1BEE7" },
  { title: "Indigo", color: "#3F51B5" },
  { title: "Blue", color: "#2196F3" },
  { title: "Light Blue", color: "#03A9F4" },
  { title: "Cyan", color: "#00BCD4" },
  { title: "Teal", color: "#009688" },
  { title: "Green", color: "#4CAF50" },
  { title: "Light Green", color: "#8BC34A" },
  { title: "Dark Green", color: "#1B5E20" },
  { title: "Yellow", color: "#FFEB3B" },
  { title: "Brown", color: "#795548" },
  { title: "Lime", color: "#CDDC39" },
  { title: "Amber", color: "#FFC107" },
  { title: "Orange", color: "#FF9800" },
  { title: "Deep Orange", color: "#FF5722" },
  { title: "Grey", color: "#607D8B" },
  { title: "Neutral Grey", color: "#9E9E9E" },
];
